export const demoTypes = {
  // Common Types
  UP_DEMO_BOOK: 'UP_DEMO_BOOK',
  // Front Types
  DEMO_BOOK_NORMAL: 'DEMO_BOOK_NORMAL',
  DEMO_BOOK_PENDING: 'DEMO_BOOK_PENDING',
  DEMO_BOOK_SUCCESS: 'DEMO_BOOK_SUCCESS',
  DEMO_BOOK_ERROR: 'DEMO_BOOK_ERROR',
};